import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { lazyBizBarArcStore, lazyLogBeaconCall, lazyLogImpressionCall } from 'owa-iris-store';
import { UpsellBanner } from './UpsellBanner';

export interface IrisUpsellBannerProps {
    lid: string;
}

function always(lightup: () => void) {
    lightup();
}

export const IrisUpsellBanner = observer(function IrisUpsellBanner(props: IrisUpsellBannerProps) {
    const bizBarArcStore = lazyBizBarArcStore.tryImportForRender();
    const upsellContentToShow = React.useMemo(() => {
        return {
            contentId: bizBarArcStore?.trackingBaseUri ?? '',
            contentMessage: bizBarArcStore?.message ?? '',
            contentLinkHref: bizBarArcStore?.userRedirectionUrl ?? '',
            contentLinkButtonText: bizBarArcStore?.userRedirectionText ?? '',
        };
    }, []);

    const onBannerClick = React.useCallback(() => {
        if (bizBarArcStore?.trackingBaseUri) {
            lazyLogBeaconCall.importAndExecute(bizBarArcStore.trackingBaseUri, 'Click');
        }
    }, []);

    const onDismiss = React.useCallback(() => {
        if (bizBarArcStore?.trackingBaseUri) {
            lazyLogBeaconCall.importAndExecute(bizBarArcStore?.trackingBaseUri, 'Dislike');
        }
    }, []);

    const onContentLinkClick = React.useCallback(() => {
        if (bizBarArcStore?.trackingBaseUri) {
            lazyLogBeaconCall.importAndExecute(bizBarArcStore?.trackingBaseUri, 'Click');
        }
    }, []);

    const onContentLoad = React.useCallback(() => {
        if (bizBarArcStore?.message) {
            lazyLogImpressionCall.importAndExecute(bizBarArcStore.impressionBaseUri);
        }
    }, []);

    return (
        <UpsellBanner
            lid={props.lid}
            when={always}
            upsellName={'IrisUpsell'}
            upsellContentToShow={upsellContentToShow}
            onContentLoadCallback={onContentLoad}
            onContentLinkCallBack={onContentLinkClick}
            onDismissCallback={onDismiss}
            onBannerClickCallback={onBannerClick}
        />
    );
});
